module.exports = global["React"] = require("-!/agent/_work/1/s/node_modules/source-map-loader/index.js!./index.js");